import React, { useEffect, useState } from 'react';
import Hero from './Hero';
import About from './About';
import GlobeSection from './home/GlobeSection';
import ScrollReveal from './ScrollReveal';
import { useScrollProgress } from '../lib/scrollFX';

const LANDING_CONTENT_URL = 'https://backend.parthmerchant.com/api/landing/content';

export default function Home() {
  const progressRef = useScrollProgress();
  const [landing, setLanding] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchLandingContent() {
      try {
        const signal = typeof AbortSignal?.timeout === 'function'
          ? AbortSignal.timeout(3000)
          : undefined;
        const res = await fetch(LANDING_CONTENT_URL, { signal });
        if (!res.ok) throw new Error(`Unexpected status ${res.status}`);
        const data = await res.json();
        if (!cancelled) setLanding(data);
      } catch (err) {
        // Network error, timeout, non-200, or bad JSON — keep hardcoded fallback.
        console.warn('Landing content fetch failed, using defaults:', err);
      }
    }

    fetchLandingContent();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      {/* Reading-progress bar — fills as you scroll the page */}
      <div className="scroll-progress" ref={progressRef} aria-hidden="true">
        <span className="scroll-progress-bar" />
      </div>

      <Hero content={landing?.hero} />
      <ScrollReveal variant="up"><About content={landing?.about} /></ScrollReveal>
      <ScrollReveal variant="blur" threshold={0.08}><GlobeSection content={landing?.globe} /></ScrollReveal>
    </>
  );
}
